import { authenticatedFetch } from "./auth.api";

const BASE_URL = process.env.REACT_APP_ZVB_URL ;

export const createAppointment = async (payload) => {
    console.log(payload)
    const res = await authenticatedFetch(BASE_URL + "/appointments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error("Failed to create appointment");
    return res.json();
};

// API call to mark a job as complete
export const completeAppointment = async (appointmentId) => {

  try {
    const response = await authenticatedFetch(`${BASE_URL}/appointments/${appointmentId}/complete`, {
      method: "PATCH",
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return await response.json();
  } catch (err) {
    console.log("Error: Transaction not complete because:", err);
    return null;
  }

}

// API call to mark a job as no show
export const noShowAppointment = async (appointmentId) => {

  try {
    const response = await authenticatedFetch(`${BASE_URL}/appointments/${appointmentId}/noshow`, {
      method: "PATCH",
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return await response.json();
  } catch (err) {
    console.log("Error: Transaction not complete because:", err);
    return null;
  }

}

// API call to mark a job as no show
export const partsRequiredAppointment = async (appointmentId) => {

  try {
    const response = await authenticatedFetch(`${BASE_URL}/appointments/${appointmentId}/partsrequired`, {
      method: "PATCH",
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return await response.json();
  } catch (err) {
    console.log("Error: Transaction not complete because:", err);
    return null;
  }

}